export const permissions = {
    General: 1,
    Admin: 5
}

export const permissionsByNumber = {
    1: "General",
    5: "Admin"
}

export const WEB_URL = process.env.NODE_ENV === 'production' ? window.origin : 'http://localhost:3000'



// WEBPACK FOOTER //
// ./src/constants.js